<template>
    <ul class="var-cross__container">
        <li class="var-cross__img-wrap" >
            <div v-tooltip :title="replaceName(activeItemColorName)" data-toggle="tooltip" data-placement="top" :data-original-title="activeItemColorName" class="var-cross__img-container var-cross__img-container--active">
                <div class="var-cross__img"
                     :style="{ backgroundImage: 'url(' + activeItemColorUrl + ')' }">
                </div>
            </div>
        </li>
        <template v-for="item in crossItems">
            <li class="var-cross__img-wrap" >
                <a v-tooltip :title="replaceName(item.colorname)" data-toggle="tooltip" data-placement="top" :data-original-title="item.colorname" :href="item.url" class="var-cross__img-container">
                    <div class="var-cross__img"
                         :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }">
                    </div>
                </a>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        name: "VariationCrossSelling",

        props: {
            crossSellingItems: Array,
            itemData: {},
            isQuick:{
                type: Boolean,
                default: false
            }
        },

        inject: {
            itemId: {
                default: null
            }
        },

        data(){
            return{
                //itemData: {}
            }
        },

        computed: {
            activeItemColorUrl(){
                const colorUrl = this.getColorUrl(this.currentVariation);
                return colorUrl || this.currentVariation.images.all[0].urlPreview;
            },
            activeItemColorName(){
                const colorName = this.getColorName(this.currentVariation);
                return colorName;
            },
            crossItems(){
                return this.crossSellingItems.map( item => {
                    let colorUrl = this.getColorUrl(item);
                    let colorName = this.getColorName(item);

                    return {
                        url: this.$options.filters.itemURL(item),
                        imgUrl: colorUrl || item.images.all[0].urlPreview,
                        colorname: colorName
                    };
                });
            },
            currentVariation() {
                if(this.isQuick){
                    return this.itemData;
                }
                return this.$store.getters[`${this.itemId}/currentItemVariation`];
            },
        },
        methods: {

            replaceName(value){

                value = value.replace("_","-").replace("ss", "ß")

                let bigLetter = value.substring(value.lastIndexOf('-')+1, value.lastIndexOf('-')+2)
                return value.replace('-'+bigLetter, '-'+bigLetter.toUpperCase())
            },

            findProperty(propID, item)
            {
                item = item || this.currentVariation;
                if (item && typeof item.variationProperties != 'undefined' && item.variationProperties.length > 0)
                {
                    const props = item.variationProperties[0].properties;
                    const propData = props.find(p => p.id === propID);
                    if (propData && propData.values && propData.values.value)
                    {
                        return propData.values.value;
                    }
                }
                return "";
            },

            getColorUrl(item){
                let colorUrl = null;
                if(item.variationProperties && item.variationProperties.length > 0){

                    const colorProp = this.findProperty(10, item);

                    if (colorProp){
                        colorUrl = "https://bilder.weberbuero.de/frontend/images/colors/thumbs/" + colorProp.toLowerCase() + ".jpg";
                    }
                }
                return colorUrl;
            },

            getColorName(item){
                let colorName = "";

                if(item.variationProperties && item.variationProperties.length > 0){

                    const colorProp = this.findProperty(10, item);

                    if (colorProp){
                        colorName = colorProp.charAt(0).toUpperCase() + colorProp.slice(1);
                    }
                }
                return colorName;
            }
        }
    }

</script>


